import React, { useEffect } from "react";
import useApi from "../../hooks/useApi";
import AdminDashboard from "./AdminDashboard";
import ClientDashboard from "./ClientDashboard";
import UserDashboard from "./UserDashboard";

const Dashboard = () => {
  const { api, abortSignal, auth } = useApi();

  useEffect(() => {
    const callApi = async () => {
      try {
        const response = await api.list("/users/dashboard");
        if (response.ok) {
        } else {
        }
      } catch (error) {}
    };
  }, []);
  return auth.user.role === "user" ? (
    <UserDashboard />
  ) : auth.user.role === "admin" ? (
    <AdminDashboard />
  ) : (
    <ClientDashboard />
  );
};

export default Dashboard;
